import { render } from "./Markdown.vue?vue&type=template&id=4d4ec3d4&scoped=true&ts=true"
import script from "./Markdown.vue?vue&type=script&lang=ts"
export * from "./Markdown.vue?vue&type=script&lang=ts"

import "./Markdown.vue?vue&type=style&index=0&id=4d4ec3d4&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4ec3d4"]])

export default __exports__